// Every fact here comes from Samuel_Bruno_CV.pdf. Do not add claims that are not in the CV.

export const contact = {
    email: 'samuelbruno2001@icloud.com',
    whatsappDisplay: '+39 388 649 7834',
    whatsappUrl: 'https://wa.me/393886497834',
    linkedinDisplay: 'linkedin.com/in/samuel-bruno-lnkd',
    linkedinUrl: 'https://www.linkedin.com/in/samuel-bruno-lnkd/',
};

export const ui = {
    en: {
        report: 'Technical sheet',
        docNo: 'Doc. SB-TA',
        copyLabel: 'Copy 1 · navy · original',
        switchTo: 'Leggi in italiano',
        skip: 'Skip to content',
        index: 'Sheet index',
        subject: 'Subject',
        role: 'Role',
        base: 'Base',
        service: 'In service',
        scope: 'Scope',
        attachment: 'Attachment A',
        test: 'Test',
        description: 'Description',
        measured: 'Measured',
        result: 'Result',
        pass: 'Pass',
        passed: 'Passed',
        acceptance: 'Acceptance',
        acceptanceNote: 'To accept this sheet, get in touch.',
        contactMe: 'Contact me',
        downloadCv: 'Download CV',
        signature: 'Signature',
        date: 'Date',
        schedule: 'Test schedule',
        project: 'Project',
        keyResult: 'Key result',
        openSheet: 'Open sheet',
        operator: 'Operator record',
        employer: 'Employer',
        position: 'Position',
        location: 'Location',
        period: 'Period',
        duties: 'Duties',
        education: 'Education',
        certifications: 'Certifications',
        languages: 'Languages',
        instruments: 'Instruments',
        signOff: 'Sign-off',
        signOffLead: 'Hiring for a technical lead, or have a system to build? Write to me.',
        email: 'Email',
        whatsapp: 'WhatsApp',
        linkedin: 'LinkedIn',
        sheet: 'Sheet',
        sector: 'Sector',
        stack: 'Stack',
        measurements: 'Measurements',
        inspection: 'Inspection',
        complies: 'Complies',
        status: 'Status',
        workPerformed: 'Work performed',
        backToSchedule: 'Back to the test schedule',
        previous: 'Previous sheet',
        next: 'Next sheet',
        notFound: 'Sheet not found',
        notFoundBody: 'There is no test sheet at this address. It may have been renamed or never existed.',
        void: 'Void',
        home: 'Back to the technical sheet',
        page: 'Page',
        rights: 'All rights reserved.',
        sections: { results: 'Results', schedule: 'Schedule', operator: 'Operator', instruments: 'Instruments', signoff: 'Sign-off' },
    },
    it: {
        report: 'Scheda tecnica',
        docNo: 'Doc. SB-TA',
        copyLabel: 'Copia 2 · bordeaux · cliente',
        switchTo: 'Read in English',
        skip: 'Vai al contenuto',
        index: 'Indice della scheda',
        subject: 'Soggetto',
        role: 'Ruolo',
        base: 'Sede',
        service: 'In servizio',
        scope: 'Oggetto',
        attachment: 'Allegato A',
        test: 'Prova',
        description: 'Descrizione',
        measured: 'Misurato',
        result: 'Esito',
        pass: 'Superato',
        passed: 'Superato',
        acceptance: 'Accettazione',
        acceptanceNote: 'Per accettare questa scheda, contattami.',
        contactMe: 'Contattami',
        downloadCv: 'Scarica il CV',
        signature: 'Firma',
        date: 'Data',
        schedule: 'Elenco progetti',
        project: 'Progetto',
        keyResult: 'Risultato chiave',
        openSheet: 'Apri la scheda',
        operator: 'Scheda operatore',
        employer: 'Azienda',
        position: 'Posizione',
        location: 'Luogo',
        period: 'Periodo',
        duties: 'Mansioni',
        education: 'Istruzione',
        certifications: 'Certificazioni',
        languages: 'Lingue',
        instruments: 'Strumentazione',
        signOff: 'Firma',
        signOffLead: 'Cerchi un technical lead, o hai un sistema da costruire? Scrivimi.',
        email: 'Email',
        whatsapp: 'WhatsApp',
        linkedin: 'LinkedIn',
        sheet: 'Scheda',
        sector: 'Settore',
        stack: 'Stack',
        measurements: 'Misure',
        inspection: 'Ispezione',
        complies: 'Conforme',
        status: 'Esito',
        workPerformed: 'Lavori eseguiti',
        backToSchedule: 'Torna all’elenco progetti',
        previous: 'Scheda precedente',
        next: 'Scheda successiva',
        notFound: 'Scheda non trovata',
        notFoundBody: 'A questo indirizzo non c’è nessuna scheda progetto. Potrebbe essere stata rinominata o non essere mai esistita.',
        void: 'Annullato',
        home: 'Torna alla scheda tecnica',
        page: 'Pagina',
        rights: 'Tutti i diritti riservati.',
        sections: { results: 'Esiti', schedule: 'Progetti', operator: 'Operatore', instruments: 'Strumenti', signoff: 'Firma' },
    },
};

export const profile = {
    name: 'Samuel Bruno',
    role: 'Software Engineer | Technical Lead',
    en: {
        base: 'Catania, Italy',
        service: '6+ years',
        scope: 'I take software from requirements to production: architecture, real-time hardware integration, cloud delivery, and the team that builds it.',
        metaDescription: 'Samuel Bruno, software engineer and technical lead. Flutter, React, Next.js and Node.js systems with real-time hardware integration, taken from requirements to production.',
    },
    it: {
        base: 'Catania, Italia',
        service: 'Oltre 6 anni',
        scope: 'Porto il software dai requisiti alla produzione: architettura, integrazione hardware in tempo reale, delivery in cloud e il team che lo costruisce.',
        metaDescription: 'Samuel Bruno, software engineer e technical lead. Sistemi Flutter, React, Next.js e Node.js con integrazione hardware in tempo reale, dai requisiti alla produzione.',
    },
};

// Hero results: each row points at the sheet and check it was measured on.
// Checks without a countable value from the CV carry value: null and show a dash.
export const headlineResults = [
    {
        project: 'trainerapp',
        check: 'TA-01.1',
        value: { en: '600+', it: '600+' },
        text: {
            en: 'Gyms, trainers and pro sports organisations using TrainerApp',
            it: 'Palestre, trainer e organizzazioni sportive che usano TrainerApp',
        },
    },
    {
        project: 'caronte',
        check: 'TA-02.1',
        value: { en: '20+', it: '20+' },
        text: {
            en: 'Manufacturing companies running the Caronte IoT platform',
            it: 'Aziende manifatturiere che usano la piattaforma IoT Caronte',
        },
    },
    {
        project: 'trainerapp',
        check: 'TA-01.2',
        value: { en: '1,000 Hz', it: '1.000 Hz' },
        text: {
            en: 'BLE sensor acquisition, drawn live on screen in under 100 ms',
            it: 'Acquisizione sensore via BLE, disegnata a schermo in meno di 100 ms',
        },
    },
];

export const projects = [
    {
        slug: 'trainerapp',
        id: 'TA-01',
        name: 'TrainerApp',
        stack: ['Flutter', 'Node.js', 'REST API', 'BLE', 'Firebase', 'Real-time charts'],
        en: {
            role: 'Full-Stack Developer & Project Manager',
            sector: 'Sports technology',
            summary: 'Cross-platform Flutter app for professional sports-performance analysis, taken from the first architecture to the production release.',
            key: { value: '600+', text: 'gyms, trainers and pro organisations' },
            checks: [
                { value: '600+', text: 'Gyms, personal trainers and professional sports organisations using it, across football, basketball, tennis and golf' },
                { value: '1,000 Hz', text: 'Sensor sampling on custom proprietary hardware over BLE, with live force, power and range of motion' },
                { value: '< 100 ms', text: 'Visual latency of the high-frequency real-time charts' },
                { value: '~18 months', text: 'As project manager: product roadmap, sprint planning and the direct client relationship' },
            ],
            work: [
                'Designed and built the Node.js microservices and REST APIs for authentication, users, training sessions and data sync.',
                'Implemented real-time BLE communication with custom proprietary hardware acquiring sensor data at 1,000 Hz.',
                'Built the high-frequency chart rendering that computes force, power and range of motion live during training.',
                'Coordinated engineering, design and client stakeholders across the whole product life cycle.',
            ],
        },
        it: {
            role: 'Full-Stack Developer & Project Manager',
            sector: 'Tecnologia sportiva',
            summary: 'App Flutter cross-platform per l’analisi delle prestazioni sportive professionali, dall’architettura iniziale alla pubblicazione in produzione.',
            key: { value: '600+', text: 'palestre, trainer e organizzazioni' },
            checks: [
                { value: '600+', text: 'Palestre, personal trainer e organizzazioni sportive professionistiche che la usano, tra calcio, basket, tennis e golf' },
                { value: '1.000 Hz', text: 'Campionamento del sensore su hardware proprietario via BLE, con calcolo live di forza, potenza e range of motion' },
                { value: '< 100 ms', text: 'Latenza visiva dei grafici real-time ad alta frequenza' },
                { value: '~18 mesi', text: 'Come project manager: roadmap di prodotto, sprint planning e relazione diretta con il cliente' },
            ],
            work: [
                'Progettazione e sviluppo dei microservizi Node.js e delle REST API per autenticazione, utenti, sessioni di allenamento e sincronizzazione dei dati.',
                'Comunicazione BLE real-time con hardware proprietario che acquisisce i dati del sensore a 1.000 Hz.',
                'Rendering grafico ad alta frequenza che calcola forza, potenza e range of motion durante l’allenamento.',
                'Coordinamento di engineering, design e stakeholder del cliente per l’intero ciclo di vita del prodotto.',
            ],
        },
    },
    {
        slug: 'caronte',
        id: 'TA-02',
        name: 'Caronte',
        stack: ['React', 'WebSocket', 'PostgreSQL', 'Industrial IoT'],
        en: {
            role: 'Full-Stack Developer',
            sector: 'Manufacturing',
            summary: 'Industrial IoT monitoring platform. Sole owner of the whole frontend, from concept to production.',
            key: { value: '20+', text: 'manufacturing companies' },
            checks: [
                { value: '20+', text: 'Manufacturing companies running the platform' },
                { value: null, text: 'Sole owner of the entire client-side engineering layer, from concept to production' },
                { value: null, text: 'Real-time operational dashboards for machine status, production orders, alarms and automation control' },
            ],
            work: [
                'Designed and implemented the entire frontend architecture of the platform.',
                'Built real-time dashboards that let operators detect and respond to critical production events as they happen.',
                'Defined the end-to-end UX information architecture for complex operational interfaces.',
                'Contributed to the database schema, keeping live PLC data feeds consistent with the persistent reporting layer.',
            ],
        },
        it: {
            role: 'Full-Stack Developer',
            sector: 'Manifatturiero',
            summary: 'Piattaforma di monitoraggio IoT industriale. Unico responsabile dell’intero frontend, dal concept alla produzione.',
            key: { value: '20+', text: 'aziende manifatturiere' },
            checks: [
                { value: '20+', text: 'Aziende manifatturiere che usano la piattaforma' },
                { value: null, text: 'Unico responsabile dell’intero layer di ingegneria lato client, dal concept alla produzione' },
                { value: null, text: 'Dashboard operative real-time per stato macchine, ordini di produzione, allarmi e controllo dell’automazione' },
            ],
            work: [
                'Progettazione e implementazione dell’intera architettura frontend della piattaforma.',
                'Dashboard real-time che permettono agli operatori di rilevare e gestire gli eventi critici di produzione mentre accadono.',
                'Definizione dell’architettura informativa UX end-to-end per interfacce operative complesse.',
                'Contributo allo schema del database, mantenendo coerenti i feed dati PLC live e il layer di reportistica persistente.',
            ],
        },
    },
    {
        slug: 'medical',
        id: 'TA-03',
        name: 'Medical',
        stack: ['Flutter', 'WebSocket', 'Medical hardware integration'],
        en: {
            role: 'Lead Flutter Developer',
            sector: 'Medical research',
            summary: 'Private therapeutic mobile app integrated with proprietary medical hardware, supporting active Alzheimer’s-prevention research programmes.',
            key: { value: null, text: 'Real-time link to proprietary medical hardware' },
            checks: [
                { value: null, text: 'Bidirectional real-time communication pipeline with proprietary medical hardware over WebSocket' },
                { value: null, text: 'Complete UI/UX, from concept to production release' },
                { value: null, text: 'Built to medical usability standards for clinical data-collection workflows' },
            ],
            work: [
                'Designed and developed the mobile app and its integration with the medical hardware over WebSocket.',
                'Delivered the complete UI/UX, from concept to production release.',
                'Implemented the bidirectional real-time hardware communication pipeline.',
            ],
        },
        it: {
            role: 'Lead Flutter Developer',
            sector: 'Ricerca medica',
            summary: 'App mobile terapeutica privata integrata con hardware medico proprietario, a supporto di programmi di ricerca attivi sulla prevenzione dell’Alzheimer.',
            key: { value: null, text: 'Collegamento real-time con hardware medico proprietario' },
            checks: [
                { value: null, text: 'Pipeline di comunicazione bidirezionale real-time con hardware medico proprietario via WebSocket' },
                { value: null, text: 'UI/UX completa, dal concept al rilascio in produzione' },
                { value: null, text: 'Nel rispetto degli standard di usabilità medicale per i workflow di raccolta dati clinici' },
            ],
            work: [
                'Progettazione e sviluppo dell’app mobile e della sua integrazione con l’hardware medico via WebSocket.',
                'Realizzazione completa della UI/UX, dal concept al rilascio in produzione.',
                'Implementazione della pipeline di comunicazione hardware bidirezionale in tempo reale.',
            ],
        },
    },
    {
        slug: 'importyourcard',
        id: 'TA-04',
        name: 'ImportYourCard',
        stack: ['Flutter', 'iOS', 'Android', 'Google Vision OCR'],
        en: {
            role: 'Full-Stack Developer',
            sector: 'Mobile productivity',
            summary: 'Cross-platform iOS and Android app that extracts contacts from business cards with Google Vision OCR.',
            key: { value: '2 stores', text: 'App Store and Google Play' },
            checks: [
                { value: '2 stores', text: 'Published on the App Store and Google Play' },
                { value: '1 codebase', text: 'The whole application stack from a single codebase' },
                { value: null, text: 'Automatic contact extraction from business cards with Google Vision OCR' },
            ],
            work: [
                'Owned database design, API coordination, UI/UX and store publishing.',
                'Designed a smooth contact-import workflow that meets the distribution standards of both platforms.',
            ],
        },
        it: {
            role: 'Full-Stack Developer',
            sector: 'Produttività mobile',
            summary: 'App cross-platform iOS e Android che estrae i contatti dai biglietti da visita con Google Vision OCR.',
            key: { value: '2 store', text: 'App Store e Google Play' },
            checks: [
                { value: '2 store', text: 'Pubblicata su App Store e Google Play' },
                { value: '1 codebase', text: 'L’intero stack applicativo da un’unica codebase' },
                { value: null, text: 'Estrazione automatica dei contatti dai biglietti da visita con Google Vision OCR' },
            ],
            work: [
                'Responsabilità su database design, coordinamento API, UI/UX e pubblicazione sugli store.',
                'Workflow di importazione dei contatti fluido e conforme agli standard di distribuzione di entrambe le piattaforme.',
            ],
        },
    },
    {
        slug: 'polimer-ing',
        id: 'TA-05',
        name: 'Polimer ING',
        stack: ['Next.js', 'SQL Server', 'Analytics'],
        en: {
            role: 'Full-Stack Developer',
            sector: 'Industrial analytics',
            summary: 'Industrial analytics platform in Next.js with SQL Server, configurable operational dashboards and dynamic questionnaire modules.',
            key: { value: null, text: 'Configurable operational dashboards on SQL Server' },
            checks: [
                { value: null, text: 'Configurable operational dashboards on SQL Server data' },
                { value: null, text: 'Dynamic questionnaire modules for the client’s reporting and process documentation' },
            ],
            work: [
                'Developed the Next.js platform and its SQL Server integration.',
                'Built the configurable dashboards and the dynamic questionnaire modules.',
            ],
        },
        it: {
            role: 'Full-Stack Developer',
            sector: 'Analytics industriale',
            summary: 'Piattaforma analitica industriale in Next.js con SQL Server, dashboard operative configurabili e moduli di questionario dinamici.',
            key: { value: null, text: 'Dashboard operative configurabili su SQL Server' },
            checks: [
                { value: null, text: 'Dashboard operative configurabili sui dati SQL Server' },
                { value: null, text: 'Questionari dinamici per la reportistica e la documentazione di processo del cliente' },
            ],
            work: [
                'Sviluppo della piattaforma Next.js e dell’integrazione con SQL Server.',
                'Realizzazione delle dashboard configurabili e dei moduli di questionario dinamici.',
            ],
        },
    },
];

export const operator = {
    employer: 'C2T',
    position: 'Software Engineer & Technical Lead',
    period: { en: '2020 – present', it: '2020 – oggi' },
    location: { en: 'Catania, Italy', it: 'Catania, Italia' },
    duties: {
        en: [
            'Main technical reference for 3 enterprise clients at once, in a 10-person consultancy: manufacturing, sports technology and medical research.',
            'Leads a cross-functional team of 3 (frontend developer, backend developer, UI/UX designer) with architecture guidance, code review standards and daily mentoring.',
            'Moves between business analyst, software engineer, technical lead and project manager as each project phase requires.',
            'Runs requirements sessions with enterprise stakeholders and turns them into technical specs, database schemas, UI/UX wireframes and development tasks.',
            'Designs backends with REST APIs, microservices, real-time WebSocket pipelines, BLE hardware protocols and cloud services on Azure, Google Cloud and Firebase.',
            'Owns frontend architecture across React, Next.js, Flutter and React Native, with shared component patterns, design-system standards and state management.',
            'Manages sprints, timelines and stakeholder expectations with Agile/Scrum across parallel client projects.',
        ],
        it: [
            'Riferimento tecnico principale per 3 clienti enterprise in contemporanea, in una società di consulenza di 10 persone: manifatturiero, tecnologia sportiva e ricerca medica.',
            'Guida un team cross-funzionale di 3 figure (sviluppatore frontend, sviluppatore backend, UI/UX designer) con indirizzo architetturale, standard di code review e mentoring quotidiano.',
            'Assume i ruoli di business analyst, software engineer, technical lead e project manager secondo la fase del progetto.',
            'Conduce l’analisi dei requisiti con gli stakeholder enterprise e la traduce in specifiche tecniche, schemi di database, wireframe UI/UX e task di sviluppo.',
            'Progetta backend con REST API, microservizi, pipeline WebSocket real-time, protocolli BLE verso l’hardware e servizi cloud su Azure, Google Cloud e Firebase.',
            'Responsabile dell’architettura frontend su React, Next.js, Flutter e React Native, con pattern a componenti, standard di design system e state management condivisi.',
            'Gestisce sprint, timeline e aspettative degli stakeholder con Agile/Scrum su progetti cliente in parallelo.',
        ],
    },
    education: [
        {
            title: { en: 'Bachelor’s in Computer Engineering', it: 'Laurea triennale in Ingegneria Informatica' },
            place: { en: 'University of Catania', it: 'Università degli Studi di Catania' },
            period: { en: '2023 – in progress', it: '2023 – in corso' },
        },
        {
            title: { en: 'Diploma in IT & Telecommunications', it: 'Diploma in Informatica e Telecomunicazioni' },
            place: { en: 'State Technical Institute · final mark 100/100', it: 'Istituto Tecnico Statale · voto finale 100/100' },
            period: { en: '2015 – 2020', it: '2015 – 2020' },
        },
    ],
    certifications: [
        'AI Fluency: Framework & Foundations',
        'AI Fluency for Builders',
        'Claude Code 101',
        'Claude Platform 101',
        'Building with the Claude API',
    ],
    languages: {
        en: ['Italian · native', 'English · B2, professional'],
        it: ['Italiano · madrelingua', 'Inglese · B2, professionale'],
    },
};

export const instruments = [
    { label: { en: 'Frontend', it: 'Frontend' }, items: 'React, Next.js, Flutter, React Native, Tailwind CSS, responsive design' },
    { label: { en: 'Backend & API', it: 'Backend & API' }, items: 'Node.js, REST API, WebSocket, BLE communication, Google Vision OCR' },
    { label: { en: 'Databases', it: 'Database' }, items: 'PostgreSQL, SQL Server, MongoDB, Firebase Realtime Database' },
    { label: { en: 'Cloud & infrastructure', it: 'Cloud & infrastruttura' }, items: 'Azure, Google Cloud Platform, AWS, Firebase, Docker, Nginx, Linux' },
    { label: { en: 'DevOps & tools', it: 'DevOps & strumenti' }, items: 'GitHub Actions, Git, CI/CD pipelines, Docker Compose' },
    { label: { en: 'Languages', it: 'Linguaggi' }, items: 'TypeScript, JavaScript, Dart, Java, C#, .NET, C, SQL' },
    { label: { en: 'AI', it: 'AI' }, items: 'AI agents, LLM, MCP, RAG' },
    {
        label: { en: 'Architecture', it: 'Architettura' },
        items: { en: 'System design, database design, real-time systems, UI/UX design, API contracts', it: 'System design, database design, sistemi real-time, UI/UX design, contratti API' },
    },
    {
        label: { en: 'Methods', it: 'Metodologie' },
        items: { en: 'Agile, Scrum, technical leadership, project management, requirements analysis, cross-functional team coordination', it: 'Agile, Scrum, leadership tecnica, project management, analisi dei requisiti, coordinamento di team cross-funzionali' },
    },
];
